import { ViewStream } from "spyne";
import { UiBreadcrumbItem } from "components/ui/ui-breadcrumb-item";

export class UiBreadcrumbHolder extends ViewStream {
  constructor(props = {}) {
    props.class = "breadcrumb-items";
    props.tagName = "nav";
    // props.template = require('./templates/ui-breadcrumb-holder.tmpl.html');
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT", "onDocsItemChanged"]];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onDocsItemChanged(e) {
    const { payload } = e;
    const { docsBreadcrumbData } = payload;

    const { breadcrumbData, lastLevelNum } = docsBreadcrumbData;

    const forEachBreadCrumbItem = (o) => {
      const { data } = o;

      //if (data.menuData.contentLevel <= lastLevelNum){
      this?.appendView(new UiBreadcrumbItem({ data }));

      // }
    };

    const onDelayAddItems = () => breadcrumbData.forEach(forEachBreadCrumbItem);
    requestAnimationFrame(onDelayAddItems);
    // window.setTimeout(onDelayAddItems, 200);

    //console.log("HOLDER ",{docsBreadcrumbData, payload})
  }

  addBreadcrumbItems() {
    const addItem = (obj) => {
      const { data } = obj;
      //const {breadcrumbItemData} = obj;
      //const data = breadcrumbItemData;
      this.appendView(new UiBreadcrumbItem({ data }));
    };

    this.props.data.breadcrumbData.forEach(addItem);
  }

  onRendered() {
    this.addChannel("CHANNEL_APP_ROUTE");

    this.addBreadcrumbItems();
  }
}
